module.exports = __webpack_public_path__ + "img/emmy_updated.a7dcbc75.png";